export const newLine = "\n";
export var DrawRecordTypes;
(function (DrawRecordTypes) {
    DrawRecordTypes["arc"] = "A";
    DrawRecordTypes["circle"] = "C";
    DrawRecordTypes["polyline"] = "P";
    DrawRecordTypes["rectangle"] = "S";
    DrawRecordTypes["text"] = "T";
    DrawRecordTypes["pin"] = "X";
})(DrawRecordTypes || (DrawRecordTypes = {}));
export var FootprintModuleRecordTypes;
(function (FootprintModuleRecordTypes) {
    FootprintModuleRecordTypes["description"] = "Cd";
    FootprintModuleRecordTypes["keywords"] = "Kw";
    FootprintModuleRecordTypes["solderPaste"] = ".SolderPaste";
    FootprintModuleRecordTypes["solderMask"] = ".SolderMask";
    FootprintModuleRecordTypes["solderPasteRatio"] = ".SolderPasteRatio";
    FootprintModuleRecordTypes["localClearance"] = ".LocalClearance";
    FootprintModuleRecordTypes["zoneConnection"] = ".ZoneConnection";
    FootprintModuleRecordTypes["thermalWidth"] = ".ThermalWidth";
    FootprintModuleRecordTypes["thermalGap"] = ".ThermalGap";
    FootprintModuleRecordTypes["type"] = "At";
    FootprintModuleRecordTypes["drawText"] = "T";
    FootprintModuleRecordTypes["drawLine"] = "DS";
    FootprintModuleRecordTypes["drawCircle"] = "DC";
    FootprintModuleRecordTypes["drawArc"] = "DA";
    FootprintModuleRecordTypes["drawPolygon"] = "DP";
    FootprintModuleRecordTypes["drawPolygonVertex"] = "DL";
    FootprintModuleRecordTypes["padPosition"] = "Po";
    FootprintModuleRecordTypes["padDefinition"] = "Sh";
    FootprintModuleRecordTypes["padHoleSize"] = "Dr";
    FootprintModuleRecordTypes["padType"] = "At";
    FootprintModuleRecordTypes["padToDieLength"] = "Le";
    FootprintModuleRecordTypes["padNetNumberAndName"] = "Ne";
})(FootprintModuleRecordTypes || (FootprintModuleRecordTypes = {}));
export var DefinitionRecordTypes;
(function (DefinitionRecordTypes) {
    DefinitionRecordTypes["field"] = "F";
    DefinitionRecordTypes["alias"] = "ALIAS";
})(DefinitionRecordTypes || (DefinitionRecordTypes = {}));
export var SchemaTypes;
(function (SchemaTypes) {
    SchemaTypes["library"] = "EESchema-LIBRARY";
    SchemaTypes["schematic"] = "EESchema Schematic File Version 4";
    SchemaTypes["footprint"] = "PCBNEW-LibModule-V1";
})(SchemaTypes || (SchemaTypes = {}));
export var Units;
(function (Units) {
    Units["millimetres"] = "mm";
    Units["decimil"] = "decimil";
})(Units || (Units = {}));
export var FileSectionCommands;
(function (FileSectionCommands) {
    FileSectionCommands["startDefinition"] = "DEF";
    FileSectionCommands["endDefinition"] = "ENDDEF";
    FileSectionCommands["startDraw"] = "DRAW";
    FileSectionCommands["endDraw"] = "ENDDRAW";
    FileSectionCommands["startIndex"] = "$INDEX";
    FileSectionCommands["endIndex"] = "$EndINDEX";
    FileSectionCommands["startModule"] = "$MODULE";
    FileSectionCommands["endModule"] = "$EndMODULE";
    FileSectionCommands["startPad"] = "$PAD";
    FileSectionCommands["endPad"] = "EndPAD";
})(FileSectionCommands || (FileSectionCommands = {}));
export var FileHeaderCommands;
(function (FileHeaderCommands) {
    FileHeaderCommands["units"] = "Units";
})(FileHeaderCommands || (FileHeaderCommands = {}));
export var UserDefinedFieldSchemaTypes;
(function (UserDefinedFieldSchemaTypes) {
    UserDefinedFieldSchemaTypes["SamacSys"] = "#SamacSys";
    UserDefinedFieldSchemaTypes["UltraLibrarian"] = "#UltraLibrarian";
    UserDefinedFieldSchemaTypes["Unknown"] = "#Unknown";
})(UserDefinedFieldSchemaTypes || (UserDefinedFieldSchemaTypes = {}));
export var ComponentFieldNumber;
(function (ComponentFieldNumber) {
    ComponentFieldNumber[ComponentFieldNumber["reference_field"] = 0] = "reference_field";
    ComponentFieldNumber[ComponentFieldNumber["value_field"] = 1] = "value_field";
    ComponentFieldNumber[ComponentFieldNumber["footprint_field"] = 2] = "footprint_field";
    ComponentFieldNumber[ComponentFieldNumber["datasheet_field"] = 3] = "datasheet_field";
    // NOTE: after F3, all fields should be user-defined.
    // See "2.3.2 - Description of the fields" in
    // https://dev-docs.kicad.org/en/file-formats/legacy-4-to-6/legacy_file_format_documentation.pdf
    // See importUltraLibrarianLibrary.ts for our use with UltraLibrarian metadata.
    ComponentFieldNumber[ComponentFieldNumber["user_defined_fields_1"] = 4] = "user_defined_fields_1";
    ComponentFieldNumber[ComponentFieldNumber["user_defined_fields_2"] = 5] = "user_defined_fields_2";
    ComponentFieldNumber[ComponentFieldNumber["user_defined_fields_3"] = 6] = "user_defined_fields_3";
    ComponentFieldNumber[ComponentFieldNumber["user_defined_fields_4"] = 7] = "user_defined_fields_4";
    ComponentFieldNumber[ComponentFieldNumber["user_defined_fields_5"] = 8] = "user_defined_fields_5";
    ComponentFieldNumber[ComponentFieldNumber["user_defined_fields_6"] = 9] = "user_defined_fields_6";
    ComponentFieldNumber[ComponentFieldNumber["user_defined_fields_7"] = 10] = "user_defined_fields_7";
    ComponentFieldNumber[ComponentFieldNumber["user_defined_fields_8"] = 11] = "user_defined_fields_8";
    ComponentFieldNumber[ComponentFieldNumber["user_defined_fields_9"] = 12] = "user_defined_fields_9";
})(ComponentFieldNumber || (ComponentFieldNumber = {}));
export var ComponentFieldOrientation;
(function (ComponentFieldOrientation) {
    ComponentFieldOrientation["horizontal"] = "H";
    ComponentFieldOrientation["vertical"] = "V";
})(ComponentFieldOrientation || (ComponentFieldOrientation = {}));
export var PartFieldVisibility;
(function (PartFieldVisibility) {
    PartFieldVisibility["visible"] = "V";
    PartFieldVisibility["invisible"] = "I";
})(PartFieldVisibility || (PartFieldVisibility = {}));
export var ComponentFieldVisibility;
(function (ComponentFieldVisibility) {
    ComponentFieldVisibility[ComponentFieldVisibility["visible"] = 0] = "visible";
    ComponentFieldVisibility[ComponentFieldVisibility["invisible"] = 1] = "invisible";
})(ComponentFieldVisibility || (ComponentFieldVisibility = {}));
export var ComponentFieldJustify;
(function (ComponentFieldJustify) {
    ComponentFieldJustify["left"] = "L";
    ComponentFieldJustify["right"] = "R";
    ComponentFieldJustify["center"] = "C";
})(ComponentFieldJustify || (ComponentFieldJustify = {}));
export var ComponentFieldVerticalJustify;
(function (ComponentFieldVerticalJustify) {
    ComponentFieldVerticalJustify["top"] = "T";
    ComponentFieldVerticalJustify["center"] = "C";
    ComponentFieldVerticalJustify["bottom"] = "B";
})(ComponentFieldVerticalJustify || (ComponentFieldVerticalJustify = {}));
export var ComponentFieldFontStyle;
(function (ComponentFieldFontStyle) {
    ComponentFieldFontStyle["normal"] = "N";
    ComponentFieldFontStyle["italic"] = "I";
})(ComponentFieldFontStyle || (ComponentFieldFontStyle = {}));
export var ComponentFieldFontWeight;
(function (ComponentFieldFontWeight) {
    ComponentFieldFontWeight["normal"] = "N";
    ComponentFieldFontWeight["bold"] = "B";
})(ComponentFieldFontWeight || (ComponentFieldFontWeight = {}));
export var RectangleFillColor;
(function (RectangleFillColor) {
    RectangleFillColor["filledWithForegroundColor"] = "F";
    RectangleFillColor["filledWithBackgroundColor"] = "f";
    RectangleFillColor["notFilled"] = "N";
})(RectangleFillColor || (RectangleFillColor = {}));
export var PinDirection;
(function (PinDirection) {
    PinDirection["left"] = "L";
    PinDirection["right"] = "R";
    PinDirection["up"] = "U";
    PinDirection["down"] = "D";
})(PinDirection || (PinDirection = {}));
export var PinElectricalType;
(function (PinElectricalType) {
    PinElectricalType["input"] = "I";
    PinElectricalType["output"] = "O";
    PinElectricalType["bidi"] = "B";
    PinElectricalType["tristate"] = "T";
    PinElectricalType["passive"] = "P";
    PinElectricalType["unspecified"] = "U";
    PinElectricalType["powerIn"] = "W";
    PinElectricalType["powerOut"] = "w";
    PinElectricalType["openCollector"] = "C";
    PinElectricalType["openEmitter"] = "E";
    PinElectricalType["notConnected"] = "N";
})(PinElectricalType || (PinElectricalType = {}));
//# sourceMappingURL=KicadTypes.js.map